// import { Star } from "@phosphor-icons/react";
import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { Product } from "../@types";
import { formatAsMoney } from "../helpers/numbers";
import { CirclesThreePlus } from "@phosphor-icons/react";
import { normalizeStorageUrl } from "../helpers/assetUrl";

const ProductItem: FC<{
  product: Product;
}> = ({ product }) => {
  // const [rating] = useState(Math.floor(Math.random() * 5));
  const [imageFailed, setImageFailed] = useState(false);
  const imageSrc = normalizeStorageUrl(product.images?.[0]?.path);
  return (
    <Link
      to={`/marketplace/products/${product.id}`}
      className="flex flex-col gap-2 p-2 rounded-md hover:bg-white hover:drop-shadow-md transition-all duration-300 cursor-pointer"
    >
      <div className="bg-zinc-100 aspect-square w-full rounded-md overflow-hidden">
        {imageSrc && !imageFailed ? (
          <img
            src={imageSrc}
            alt={product.name}
            onError={() => setImageFailed(true)}
            className="w-full h-full aspect-square object-cover hover:scale-105 duration-500"
          />
        ) : (
          <div className="w-full h-full flex justify-center items-center text-visaro-primary-700">
            <CirclesThreePlus size={50} />
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div className="font-medium line-clamp-2">{product.name}</div>
        {/* <div className="flex items-center gap-0.5 py-2">
          {new Array(5).fill(0).map((_, key) => {
            return (
              <Star
                weight={rating > key ? "fill" : "regular"}
                key={key}
                className={`
                    ${rating > key ? "text-visaro-orange" : "text-gray-500"}
                    `}
              />
            );
          })}
          <span className="text-xs">(200)</span>
        </div> */}
        <div className="font-medium">₦{formatAsMoney(product.price)}</div>
      </div>
    </Link>
  );
};

export default ProductItem;
